module.exports = __webpack_public_path__ + "media/images/talent/case3-badge-91d50ef73a0f2213f5850a62601c85be.png";